/*!
 * Built by Revolist
 */
import { R as RevogrViewportScroll$1, d as defineCustomElement$1 } from './revogr-viewport-scroll2.js';

const RevogrViewportScroll = RevogrViewportScroll$1;
const defineCustomElement = defineCustomElement$1;

export { RevogrViewportScroll, defineCustomElement };
